import { DataBean } from "../DataBean";

export class FixedAssetItemAddition extends DataBean {


    public async getFixedAssetItemAdditionCatalog(idItem:any,processType:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getFixedAssetItemAdditionCatalog_Number_Number", [idItem,processType]);
    }
    
}